import { InjectionToken } from '@angular/core';
import { CoreRootConfig } from '../core/models/root-config';


export const CoreConfigService = new InjectionToken<CoreRootConfig>("CoreRootConfig");
